export default function Logo({ size = "md", inverse = false, showByline = true }) {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-4xl",
    xl: "text-6xl",
  };
  return (
    <div className="flex items-center gap-2" data-testid="reyansh-logo">
      <span className={`w-3 h-3 ${inverse ? "bg-white" : "bg-[#D90429]"} inline-block`} />
      <div className="leading-none">
        <span className={`font-display font-black tracking-tighter ${sizes[size]} ${inverse ? "text-white" : "text-[#0A0A0A]"}`}>
          REYANSH
        </span>
        {showByline && (
          <div className={`font-mono-shelv text-[8px] tracking-[0.25em] uppercase mt-0.5 ${inverse ? "text-white/60" : "text-[#717680]"}`}>
            by Shelvestech
          </div>
        )}
      </div>
    </div>
  );
}
